import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StyxMemberCardComponent } from './card/member-card.component';
import { StyxMemberCardTriggerDirective } from './card/member-card-trigger.directive';
import { ThyAvatarModule } from 'ngx-tethys';

@NgModule({
    imports: [CommonModule, ThyAvatarModule],
    declarations: [StyxMemberCardComponent, StyxMemberCardTriggerDirective],
    entryComponents: [StyxMemberCardComponent],
    exports: [StyxMemberCardComponent, StyxMemberCardTriggerDirective]
})
export class NgxStyxMemberModule {}
